module.exports = __webpack_public_path__ + "img/1716873829580-WhatsApp Image 2024-05-28 at 13.23.05 1.jpeg.a6638561.webp";